import { ContentListAll } from './ContentListAll';
export default ContentListAll;